<template>
  <section>
    <div :class="[($mq.phone || state.currentStep === 2) ? 'bg-white' : 'bg-gray']">
      <section>
        <router-view/>
      </section>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        state: 'booking/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      checkLogin () {
        if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
          if (this.user === null) {
            this.$parent.openModal('login')
          }
        } else {
          this.$parent.openModal('login')
        }
      }
    },
    mounted () {
      // this.checkLogin()
    }
  }
</script>

<style>
  .bg-gray {
    background: #f5f5f5;
  }

  .bg-white {
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/Index.vue